import { ChartUnit } from '@client/graphql/__generated__/types';
import { TrendingDownIcon, TrendingUpIcon } from 'lucide-react';
import { IconTag } from '~/common/components/IconTag/IconTag';
import { formatPercent } from '~/common/utils/formatter';

interface MetricTrendTagProps {
  trend: number;
  trendPeriod?: string;
  unit: ChartUnit;
}

export const MetricTrendTag = ({
  trend,
  trendPeriod,
  unit,
}: MetricTrendTagProps) => {
  const trendFormatter = ({
    value,
    unit,
  }: {
    value: number;
    unit: ChartUnit;
  }) => {
    if (unit === ChartUnit.PERCENT) {
      if (!value) return 'N/A';

      return `${value > 0 ? '+' : ''}${formatPercent(value, 1)}`;
    } else if (unit === ChartUnit.DAYS) {
      if (!value) return 'N/A';

      return `${value > 0 ? '+' : ''}${value} days`;
    }

    return value.toString();
  };

  const isTrendingUp = trend > 0;

  const label = `${trendFormatter({ value: trend, unit })} ${trendPeriod}`;

  return (
    <IconTag
      bgColor="badge.bg"
      color="badge.text"
      icon={isTrendingUp ? TrendingUpIcon : TrendingDownIcon}
      iconColor={isTrendingUp ? 'green.500' : 'red.500'}
      label={label}
    />
  );
};
